export const prismicEndpoint = 'https://catalyst.prismic.io/api/v2';
